import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import { SwapCartBundleModal, SwapCartBundleState } from 'src/components/SwapCartBundleModal/SwapCartBundleModal';
import { redesignV2RoutePath } from 'src/constants/redesignV2';
import { AddBundleOptions, CartContext } from './CartContext';
import { useCartInternal } from './UseCartInternal';
import { getCartDataFromLocalStorage } from './Util';

const initialCartData = getCartDataFromLocalStorage();

export const CartProvider: React.FC = ({ children, ...props }) => {
  const location = useLocation();
  const history = useHistory();
  const value = useCartInternal(initialCartData);
  const [swapCartBundleState, setSwapCartBundleState] = useState<SwapCartBundleState | undefined>();
  const currentBundleId = value.cart.bundle?.id;

  const addBundleById = (bundleId: string, { needsConfirm, needsRedirect }: AddBundleOptions = {}) => {
    if (currentBundleId === bundleId) return;
    if (currentBundleId && needsConfirm) {
      setSwapCartBundleState({ bundleId, needsRedirect });
    } else {
      value.addBundleById(bundleId);
      if (needsRedirect && location.pathname !== redesignV2RoutePath.CART) {
        history.push(redesignV2RoutePath.CART);
      }
    }
  };

  useEffect(() => {
    if (swapCartBundleState) setSwapCartBundleState(undefined);
  }, [currentBundleId]);

  return (
    <CartContext.Provider
      {...props}
      value={{ ...value, addBundleById }}
    >
      {children}
      <SwapCartBundleModal bundleState={[swapCartBundleState, setSwapCartBundleState]} />
    </CartContext.Provider>
  );
};

CartProvider.displayName = 'CartProvider';
